import React, { Component } from 'react';
import * as XLSX from 'xlsx/dist/xlsx.extendscript';
import { make_cols } from './MakeColumns.jsx';
import { SheetJSFT } from './types.jsx';
import { getDataFromPartnerAPI } from '../HandleAPICalls/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import {
	saveBulkUsers,
} from './actions';
import './organization.css';
import { Image, Popup } from 'semantic-ui-react';

class FileParser extends Component {
	constructor(props) {
		super(props);
		this.state = {
			file: {},
			data: [],
			cols: [],
			selectedFile: false
		}
		this.handleFile = this.handleFile.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.cancelUpload = this.cancelUpload.bind(this);
	}

	handleChange(e) {
		const files = e.target.files;
		if (files && files[0]) this.setState({ file: files[0], selectedFile: true });
	};


	cancelUpload() {
		this.setState({ data: [], cols: [], file: {}, selectedFile: false });
	}

	handleFile() {

		/* Boilerplate to set up FileReader */
		const reader = new FileReader();
		const rABS = !!reader.readAsBinaryString;
		reader.onload = (e) => {
			/* Parse data */
			const bstr = e.target.result;
			const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
			/* Get first worksheet */
			const wsname = wb.SheetNames[0];
			const ws = wb.Sheets[wsname];
			/* Convert array of arrays */
			const data = XLSX.utils.sheet_to_json(ws);
			/* Update state */
			this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
			});
			const activeId = localStorage.getItem('activeItem');
			this.props.getDataFromPartnerAPI(
				`/business-profile/${activeId}`,
				'POST',
				{ 'userInfoList': data },
				response => {
					this.props.saveBulkUsers(response);
					if (response.failures.length > 0) {
						toastr.error("Error adding users, make sure there is no duplicate email id or organization id")
					} else if (response.failures.length == 0 && response.usersAdded > 0) {
						this.setState({ data: [], cols: [], file: {}, selectedFile: false });
						toastr.success('Added New user successfuly');
					}
				},
				err => {
					console.log(err);
				}
			);
		};

		if (rABS) {
			reader.readAsBinaryString(this.state.file);
		} else {
			reader.readAsArrayBuffer(this.state.file);
		};
	}

	render() {
		return (
			<React.Fragment>
				{ this.state.selectedFile ? (
					<div>
						<div className="displayRow">
							<div>{this.state.selectedFile ? `File Chosen: ${this.state.file.name}` : null}</div>
							<Popup
								content='Cancel or choose another file'
								trigger={<div className="crossIcon" onClick={this.cancelUpload}>
									<Image
										src="../../assets/crossIcon.png"
									/>
								</div>}
							/>
							{/* <div className="crossIcon" onClick={this.cancelUpload}>
								<Image
									src="../../assets/crossIcon.png"
								/>
							</div> */}
						</div>
						< input
							type='submit'
							className='uploadBulkSuccess'
							value="Upload"
							onClick={this.handleFile}
						/>
					</div>
				) : (
						<label className="uploadBulk">
							<input
								type="file"
								style={{ display: "none" }}
								className="form-control"
								id="file" accept={SheetJSFT}
								onChange={this.handleChange}
							/>
							Add Users
						</label>
					)
				}
			</React.Fragment>

		)
	}
}

// export default FileParser;

function mapStateToProps({ addUserBulk }) {
	return {
		addUserBulk
	};
}

export default withRouter(
	connect(mapStateToProps, {
		getDataFromPartnerAPI,
		saveBulkUsers
	})(FileParser)
);


// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/FileParser.jsx